export default __webpack_public_path__ + "static/media/logoTextBlack.1ba3a16a.svg";